import { Button, Center, Group, Pagination, Stack } from "@mantine/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { useDeleteOrganizer, useQueryOrganizers } from "hooks/organizers";
import { OrganizersList, OrganizersSearchFilter } from "components/organizers";
import { useAppTranslation } from "hooks/useTranslation";
import { queryClient } from "utils";

const perPage = 10;

export const Organizers = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1", 10);
  const [name, setName] = useState("");
  const [activeOnly, setActiveOnly] = useState(false);
  const { t } = useAppTranslation();

  const deleteOrganizerMutation = useDeleteOrganizer(() => {});

  const { isLoading, isError, error, organizers, count } = useQueryOrganizers({
    name,
    page,
    perPage,
    activeOnly,
  });

  if (isError) {
    return (
      <div>
        {t("errors.something_went_wrong")}
        {error?.message}
      </div>
    );
  }
  if (isLoading) {
    return null;
  }

  const changePage = (page: number) => {
    setSearchParams({ page: page.toString() });
  };

  const goToOrganizer = (uid: string) => {
    navigate(`${window.location.pathname}/${uid}`);
  };

  const goToCreateOrganizer = () => {
    navigate(`${window.location.pathname}/create`);
  };

  const deleteOrganizer = async (uid: string) => {
    await deleteOrganizerMutation.mutateAsync({ uid });
    // Invalidate the organizers list after deletion
    queryClient.invalidateQueries({
      queryKey: ["organizers"],
    });
  };

  return (
    <Stack>
      <Group justify="space-between">
        <OrganizersSearchFilter
          onUpdateName={setName}
          onUpdateActiveOnly={setActiveOnly}
          activeOnly={activeOnly}
        />
        <Button onClick={goToCreateOrganizer}>{t("common.create")}</Button>
      </Group>
      <OrganizersList
        organizers={organizers || []}
        onOrganizerChosen={goToOrganizer}
        onOrganizerDelete={deleteOrganizer}
      />
      <Center mt="xl">
        <Pagination
          mr="xl"
          value={page}
          total={Math.ceil(count! / perPage)}
          onChange={changePage}
        />
      </Center>
    </Stack>
  );
};
